import SingleSelectComponent from "../../../../components/SingleSelect";


function renderStudyArmQuestion(
    show_study_arm_question: boolean,
    studyArmValue: string,
    setStudyArmValue: (val: string) => void,
    validStudyArm: boolean
): JSX.Element | null {
    const studyArmOptions = [
        { value: 'Arm A', label: 'Arm A' },
        { value: 'Arm B1', label: 'Arm B1' },
        { value: 'Arm B2', label: 'Arm B2' },
    ];

    if (!show_study_arm_question) {
        return null;
    }

    return (
        <SingleSelectComponent
            question="Which study arm are you in?"
            options={studyArmOptions}
            value={studyArmValue}
            onChange={setStudyArmValue}
            showMessage={!validStudyArm}
        />
    );
}

export default renderStudyArmQuestion;
